import type { ReactNode } from 'react';

import { getRouteApi } from '@tanstack/react-router';

import AddressSchufaColumn from './AddressSchufaColumn.tsx';
import CityAndZip from './CityAndZip.tsx';
import Headers from './Headers.tsx';
import StreetAndHouseNr from './StreetAndHouseNr.tsx';
import { useCanViewSchufa } from '~/features/leadDetails/hooks/useCanViewSchufa';

type Props = {
    addressKind: 'anschrift' | 'vorherigeAnschrift';
    antragsteller: 1 | 2;
    children?: ReactNode;
    titleHidden?: boolean;
};

const AddressFieldsLayout: React.FC<Props> = ({ addressKind, antragsteller, children, titleHidden = false }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const canViewSchufa = useCanViewSchufa(leadId);

    return (
        <div className="flex gap-3">
            <div className="min-w-0 flex-1 space-y-2">
                {/* spacer keeps the fields aligned with the Schufa column's header row */}
                {titleHidden ? (
                    canViewSchufa && <div className="h-8" data-testid="address-title-spacer" />
                ) : (
                    <Headers addressKind={addressKind} />
                )}
                <StreetAndHouseNr addressKind={addressKind} antragsteller={antragsteller} />
                <CityAndZip addressKind={addressKind} antragsteller={antragsteller} />
                {children}
            </div>
            {canViewSchufa && <AddressSchufaColumn addressKind={addressKind} antragsteller={antragsteller} />}
        </div>
    );
};

export default AddressFieldsLayout;
